<template>
  <div class="container">
    <img src="../assets/images/restaurant_suc_icon.png" alt="">
    <div class="des">支付成功</div>
    <!-- <div class="num ac"><span class="fs-60">￥</span>{{amount}}</div> -->
    <div class="btn-yellow suc-btn" @click="toOrderDetail">查看订单</div>
  </div>
</template>

<script>
    export default {
      name: 'PaySuccess',
      data () {
        return {
        }
      },
      created () {
        /** 点金小票的js，需要在head中引入 */
        let head = document.querySelector('head');
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js';
        head.appendChild(script);
      },
      mounted() {
        this.wxInit();
      },

      methods: {
        // 微信商家小票
        wxInit() {
          //初始化小票
          let mchData = {
            action: 'onIframeReady',
            displayStyle: 'SHOW_CUSTOM_PAGE'
          };
          let postData = JSON.stringify(mchData);
          window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
        },
        toOrderDetail () {
          localStorage.setItem('paySource','kq')
          var mchData = {
            action: 'jumpOut',
            jumpOutUrl: 'https://alywechat.anlaiye.com/orderdetail', //跳转的页面
          };
          const postData = JSON.stringify(mchData);
          window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
          // this.$router.replace({ name: 'OrderDetail' })
        }
      }

    }
</script>

<style scoped>
.container {
  background: #fff;
  height: 100vh;
  color: #2F2F2F;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
}
.container img{
  width: 1.6rem;
  margin-top: 2rem;
}
.des {
  font-size: .48rem;
  text-align: center;
  padding-top: .5rem;
}
.name {
  font-size: .32rem;
  margin-bottom: .30rem;
}
.fs-60{
  font-size: .6rem;
}
.num{
  font-size: .84rem;
  color: #000000;
  font-weight: bold;
}
.suc-btn{
  border-radius: 48px;
  background: #FFDF00;
  width: 3.96rem;
  height: .9rem;
  line-height: .9rem;
  text-align: center;
  font-size: .32rem;
  margin: 2rem auto 0;
}
</style>



// WEBPACK FOOTER //
// PaySuccess.vue?7528ba47